import * as React from 'react';

import wrapStore from '@src/utils/wrap-store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Store from './store';

import BackgroundImage from '@src/components/background-image';
import Link from '@src/components/link';

const styles = require('./index.less');

function AudioList({ store }) {
  store.use();

  const handleClick = e => {
    const index = e.target.getAttribute('data-index');
    console.log('index', index);
    if (index !== undefined) {
      store.select(Number(index));
    }
  };

  return (
    <div className={styles.videoList}>
      {store.videoList?.length > 0 && (
        <div className={styles.currentImageWrapper}>
          <BaseSwiper store={store.videoImageSwiperStore}>
            {store.videoList?.map((item, index) => (
              <div key={index}>
                <img className="media-video-layer-10" src={item?.cover} alt="" />
                <div className={styles.smallImageMask} />
                <div className="media-video-group-6" data-name="icon play" onClick={store.playVideo}>
                  <div className="media-video-layer-11" />
                  <div className="media-video-layer-12" />
                </div>
              </div>
            ))}
          </BaseSwiper>
        </div>
      )}
      <div className={styles.imageList}>
        {store.videoList?.length > 0 && (
          <div className={styles.smallImageWrapper}>
            <Link className={styles.prevBtn} onClick={() => store.paginationSwiperStore.goPrev()} />
            <div className={styles.smallImageSwiper}>
              <BaseSwiper store={store.paginationSwiperStore}>
                {store.videoList.map((item, index) => (
                  <div
                    className={styles.smallImage}
                    key={index}
                    onClick={() => {
                      store.select(index);
                    }}
                  >
                    <div className="media-video-layer-title media-video-layer-title-default">
                      <BackgroundImage src={item?.titleThumbNail} />
                    </div>
                    <div className="media-video-layer-title media-video-layer-title-selected">
                      <BackgroundImage src={item?.titleThumbNailSelected} />
                    </div>
                    <div className="smallImageInner" style={{ backgroundImage: `url(${item.thumb})` }} />
                  </div>
                ))}
              </BaseSwiper>
            </div>
            <Link className={styles.nextBtn} onClick={() => store.paginationSwiperStore.goNext()} />
          </div>
        )}
      </div>
    </div>
  );
}

export default wrapStore(AudioList, Store);
